import AmplitudeHelper from '@utils/analytics';
import { AMPLITUDE_CONSTANTS } from '@utils/analytics/constants';
import { getDateInFormatLocale } from '@utils/dateUtils';
import { getBoundary } from './paymentCyclesUtils';

interface PaymentCycle {
  startDate?: string;
  endDate?: string;
  [key: string]: any;
}

export default function logCycles(paymentCycles: PaymentCycle[], selectedPCIdx: number): void {
  if (getBoundary(selectedPCIdx, paymentCycles)) return;

  const e = AMPLITUDE_CONSTANTS.TransactionPage.cycle_changed;
  const { startDate = '', endDate = '' } = paymentCycles[selectedPCIdx];

  AmplitudeHelper.logEvent(e.name, {
    [e.attributes.source]: 'transaction_page',
    [e.attributes.start_cycle_date]: getDateInFormatLocale(startDate, 'DD MMM YYYY'),
    [e.attributes.end_cycle_date]: getDateInFormatLocale(endDate, 'DD MMM YYYY'),
  });
}

// Remove unused test function or implement it properly
